import styled from 'styled-components'
import ReactSlider from 'rc-slider'
import { Colors } from 'cio-design-library/design-tokens'

const handleSize = 24

export const DotStyle: React.CSSProperties = {
  position: 'absolute',
  top: '50%',
  width: '2px',
  height: '8px',
  margin: '-4px 0 0 -1px',
  backgroundColor: Colors.Neutral70,
}

export const Slider = styled(ReactSlider)`
  position: relative;
  flex-grow: 1;
  margin: 0 8px 0 0;
  height: ${handleSize}px;

  & .rc-slider-rail {
    position: absolute;
    left: 0;
    top: 50%;
    width: 100%;
    height: 2px;
    margin-top: -1px;
    background-color: ${Colors.Neutral70};
  }
`

export const HandleWrapper = styled.div<{ disabled?: boolean; position?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${handleSize}px;
  height: ${handleSize}px;
  border-radius: 50%;
  background-color: ${props => (props.disabled ? Colors.Neutral70 : Colors.White)};
  outline: none;
  touch-action: pan-x;
  cursor: grab;
  position: absolute;

  & svg {
    width: 16px;
    height: 16px;
    fill: ${Colors.White};
    position: absolute;
    z-index: 1;
  }
`
